// 런타임 설정 타입 접근자.
// 값은 빌드 후 public/runtime-config.js가 window.__RUNTIME_CONFIG__에 주입한다.
// 비밀값은 포함하지 않는다(공개 가능한 값만).

/** 런타임에 주입되는 공개 설정 형태. */
export interface RuntimeConfig {
    /** 백엔드 API 베이스 URL. 보통 동일 출처의 "/api". */
    API_BASE_URL: string
    /** knoka OIDC Issuer(베이스 URL). authorize URL 폴백 구성에 쓴다. */
    KNOKA_ISSUER: string
    /** knoka OIDC 클라이언트 ID(public). */
    KNOKA_CLIENT_ID: string
    /** OIDC 콜백 redirect URI. knoka 등록 값과 일치해야 한다. */
    OIDC_REDIRECT_URI: string
}

declare global {
    interface Window {
        __RUNTIME_CONFIG__?: Partial<RuntimeConfig>
    }
}

const DEFAULTS: RuntimeConfig = {
    API_BASE_URL: '/api',
    KNOKA_ISSUER: '',
    KNOKA_CLIENT_ID: '',
    OIDC_REDIRECT_URI: '',
}

function readConfig(): RuntimeConfig {
    const injected =
        (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || {}
    return { ...DEFAULTS, ...injected }
}

const config = readConfig()

/** 타입 안전한 런타임 설정. 앱 전역에서 이 객체로만 설정에 접근한다. */
export const env: Readonly<RuntimeConfig> = Object.freeze(config)
